import { render, staticRenderFns } from "./distributionOrderSplitting.vue?vue&type=template&id=2a751dea&scoped=true&"
import script from "./distributionOrderSplitting.vue?vue&type=script&lang=js&"
export * from "./distributionOrderSplitting.vue?vue&type=script&lang=js&"
import style0 from "./distributionOrderSplitting.vue?vue&type=style&index=0&id=2a751dea&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a751dea",
  null
  
)

export default component.exports